<template>
	<div class="container">
		<div class="row justify-content-center align-items-center" id="baday">
			<div class="card border-secondary mt-4">
				<div class="card-body">
					<form @submit.prevent="login">
						<div class="row mb-3">
							<h3>Two Step Verification</h3>
						</div>
						<div v-if="error" class="alert alert-danger" role="alert">Invalid Verification Code!</div>
						<div class="row mb-3">
							<label for="inputVerificationCode" class="col-sm-5 col-form-label">Enter Verification Code</label>
							<div class="col-sm-7">
								<input class="form-control" type="number" id="inputVerificationCode" placeholder="eg. 267628" v-model="code" autocomplete="off"/>
							</div>
						</div>
						<div class="text-right">
							<button id="btn" class="btn btn-primary" type="submit">Continue</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import config from "../config";
export default {
	data() {
		return {
			code: "",
			error: false,
		};
	},
	methods: {
		async login() {
			// console.log(this.$route.params.id);
			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					data: {
						otp: this.code,
						user_id: this.$route.params.id,
					},
				}),
			};
			const response = await fetch(
				config.baseURL + "/login_verify",
				requestOptions
			);
			const check = await response.json();
			// console.log(check);
			if (check["Access"] && parseInt(this.$route.params.check)) {
				const requestOptions = {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						data: {
							user_id: check["user_id"],
						},
					}),
				};
				const response = await fetch(
					config.baseURL + "/save_token",
					requestOptions
				);
				const data = await response.json();
				console.log(data);
				this.$cookies.set("id", data["token_id"], "300s")
				console.log("cookie created",data['token_id'])
				//window.location = '/';
				this.$router.push('/').catch(()=>{});
				// this.$router.push("/").catch(()=>{}); //Fix for strange bug; https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
			} else if (check["Access"]) {
				const requestOptions = {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						data: {
							user_id: check["user_id"],
						},
					}),
				};
				const response = await fetch(
					config.baseURL + "/save_token",
					requestOptions
				);
				const data = await response.json();
				console.log(data);
                                this.$cookies.set("id", data["token_id"], 0);
				console.log("temp cookie created",data['token_id']);
				// window.location = '/';
				this.$router.push('/').catch(()=>{});
				// this.$router.push("/").catch(()=>{}); //Fix for strange bug; https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
			} else this.error = true;
		},
	},
	mounted() {
		$(".navbar").remove();
		// $(".navbar").hide();
	},
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

input[type="number"] {
	-moz-appearance: textfield;
}

.navbar {
	display: none;
}
.card {
	max-width: 30rem;
	background-color: #f8f8f8;
}
#baday {
	min-height: 80vh;
}
#btn {
	float: right;
}
.container {
	position: relative;
}
.container::before {
	content: "";
	background-image: url("https://quotey.io/wp-content/uploads/2020/10/robot.bmp");
	background-size: 30rem;
	background-repeat: no-repeat;
	position: absolute;
	top: 0px;
	right: 0px;
	bottom: 0px;
	left: 0px;
	opacity: 40%;
	height: 730px;
	background-position: right center;
	background-repeat: no-repeat;
	background-attachment: scroll;
	background-size: 30rem;
}
</style>
